import { render, staticRenderFns } from "./gsk.vue?vue&type=template&id=3a273c29&"
import script from "./gsk.vue?vue&type=script&lang=js&"
export * from "./gsk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports